import { createContext, useContext } from 'react';
import { useListSetting } from '../Pages/settings/Hooks';
import PropTypes from 'prop-types';

const SettingsContext = createContext({
  settings: {},
  isloading: false,
  error: null,
  refetch: () => {}
});

export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }) => {
  const { data: settings, isPending, error, refetch } = useListSetting();

  // Exclude large fields from context value
  let filteredSettings = settings;
  if (settings) {
    // eslint-disable-next-line no-unused-vars
    const { privacyHtml, faqList, termsHtml, ...rest } = settings;
    filteredSettings = rest;
  }

  // Always provide a default empty object to prevent undefined access
  // This ensures settings is never undefined, even during loading or error states
  const contextValue = {
    settings: filteredSettings || {},
    isloading: isPending || false,
    error: error || null,
    refetch: refetch || (() => {})
  };

  return (
    <SettingsContext.Provider value={contextValue}>
      {children}
    </SettingsContext.Provider>
  );
};

SettingsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};